import React from "react";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import { selectors as localeSelectors } from "../../redux/locale";

/* this is temporary */
// const localeSelectors = {};

const processTranslation = (translation, { allowJSX = true } = {}) => {
  if (translation.map) {
    if (allowJSX) {
      return translation.map((token, i) => (
        <span key={`${token}-${i}`}>{token}</span>
      ));
    } else {
      return translation.join("");
    }
  } else {
    return translation;
  }
};
const TranslateComponent = ({ translation, children, html }) => {
  if (html && translation) {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: processTranslation(translation, { allowJSX: false })
        }}
      />
    );
  }
  return <span>{processTranslation(translation) || children}</span>;
};

const Translation = connect((state, ownProps) => ({
  translation: localeSelectors.getString(
    store.getState(),
    ownProps.id,
    ownProps
  )
}))(TranslateComponent);

const PluralTranslation = connect((state, ownProps) => ({
  translation: localeSelectors.getString(
    store.getState(),
    ownProps.amount === 1 ? ownProps.singular : ownProps.plural,
    ownProps
  )
}))(TranslateComponent);

const LocalizedDateComponent = ({ translation, children }) =>
  translation || children;

const LocalizedDate = connect((state, ownProps) => ({
  translation: localeSelectors.getDate(store.getState(), ownProps.children)
}))(LocalizedDateComponent);

const t = (id, defaultTranslation, props = {}) =>
  processTranslation(localeSelectors.getString(store.getState(), id, props), {
    allowJSX: false
  }) ||
  defaultTranslation ||
  id;
const ts = (amount, singular, plural, defaultTranslation, props = {}) =>
  t(amount === 1 ? singular : plural, defaultTranslation || singular, {
    ...props,
    amount
  });

export { t, ts, Translation, LocalizedDate, PluralTranslation };
